import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCollarType } from '@store/order/selectors';
import { COLLAR_TYPE_ENUM_TRANSLATION_KEYS, isCollarTypeEnum } from '@pages/order/collar-type/CollarTypeEnum';



const CollarType = () => {
	const { t } = useTranslation('forms');

	const collarType = useSelector(selectCollarType);

	return (
		<div className='order-summary-element'>

			<h2>{t('collarType.sectionLabel')}</h2>

			<div className='summary-property'>
				<p>{isCollarTypeEnum(collarType)
					? t(COLLAR_TYPE_ENUM_TRANSLATION_KEYS[collarType])
					: '-'}
				</p>
			</div>

		</div>
	);
};

export default CollarType;